
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
  Junior Consultant
</h2>

<p class="para_main_notify">
    A Junior Consultant (Training) would be engaged in a National Skill Training Institute (NSTIs)/Central Staﬀ Training and Research Institute (CSTARI) for imparting training to the NSTI trainees in theory and practical related to its trade/preparation of syllabus.
</p>
  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                <div class="text para_cls">
                  <h3>Eligibility Criteria (Qualification and Experience)</h3>

                    <p> <span class="step_no">1</span> Bachelor’s degree either in Technology / Engineering / Vocational Education (B.Tech /B.E/B.Voc)  in	a relevant branch from AICTE/UGC/NBA	recognized	Engineering College/University or equivalent with a minimum of 2 years of post-qualification experience in relevant field.  </p> Or 
                    <p> <span class="step_no">2</span> 3 Year Diploma in a relevant branch from AICTE/UGC/NBA/SBTE recognized institute with a minimum of 5 years of relevant work experience  </p> Or
                    <p> <span class="step_no">3</span>	Ex-serviceman from Indian Armed forces with 15 years of service in related field as per equivalency through DGR. Candidate should have undergone methods of instruction course or minimum 02 years of experience in Technical Training institute of Indian Armed forces.</p> Or 
                    <p> <span class="step_no">4</span>	National Trade Certificate (NTC)/ National Apprentice Certificate (NAC) from National Council of Vocational Education and Training (NCVET previously NCVT) in relevant field with 7 years of relevant post qualification work experience.</p>
                    <p> <b> Note: </b>For details of essential qualiﬁcation of a particular trade, kindly refer	CITS	trade	syllabus	available	on <strong>https://www.cstaricalcutta.gov.in/syllCITS.aspx
                        The applicants must possess CITS certiﬁcation, i.e. National Craft Instructor Certiﬁcate (NCIC) in the relevant trade that they are applying for.
                        </strong>  </p>
                        <p>Age limit: Minimum 21 years and Maximum 30 years as on the closing date of submission of the application</p>
                        <p>The crucial date for determining the educational qualification and
 
                            experience will be the closing date of submission of the application.
                            </p>
                </div>
              </div>
            </div>
            <!-- feature box close -->
             <!-- feature box begin -->
             <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-gavel"></i>
                <div class="text para_cls">
                  <h3>Age Relaxation</h3>
          
          
                  <div class="container">
                    <div class="row">
          
                      <div class="col-md-12">
                        As per the DoPT Guidelines for relaxation - please upload the following table on the portal for providing clarity to the applicants. 
                      </div>
                      <div class="col-md-12">
                        <table>
                          <thead>
                              <th>Sl.No</th>
                              <th style="width: 50%; text-align: center;"> Type</th>
                              <th> Age</th>
                          </thead>
          
                          <tr>
                            <td>1</td>
                            <td> General  </td>
                            <td> 21-30 </td>
                          </tr>
          
                          <tr>
                            <td>2</td>
                            <td>OBC </td>
                              <td>21-33  </td>
          
                          </tr>
          
                          <tr>
                            <td>3</td>
                            <td>SC/ST </td>
                            <td>21-35</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>PwD</td>
                            <td>21-40 </td>
                          </tr>
          
                          <tr>
                            <td>5</td>
                            <td>Ex-Servicemen   </td>
                            <td> 21-33**   </td>
                          </tr>
                          <!-- <tr style="border-bottom: 1px solid #999;">
                            <td>6</td>
                            <td>Sixth Preference    </td>
                            <td> Retired Govt. Employee with experience in the relevant field    </td>
                          </tr> -->
                        </table>
                        <br>
                        <div class="col-md-12">
                          **SPECIAL PROVISION REGARDING AGE LIMIT For appointment to any vacancy in Central Civil Services Group ‘C’ and Group ‘D’ whether reserved or not under these rules, every ex-Servicemen who has put in not less than six months continuous service in the Armed Forces of the Union shall be allowed to deduct the period of such service from his actual age and if the resultant age does not exceed the maximum age limit prescribed for the post or service for which he seeks appointment by more than three years, he shall be deemed to satisfy the condition regarding age limit. 
                        </div>
                      </div>
                    </div>
                  </div>
          
                </div>
              </div>
            </div>
              <!-- feature box close -->

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-gavel"></i>
            <div class="text para_cls">
              <h3>	General Terms & Conditions </h3>

              <p> <span class="step_no">1</span>Junior Consultants (JCs) will be engaged for a period of eleven months from the date of Engagement. </p>
              <p> <span class="step_no">2</span>The services of JCs may be extended for a period of another 11 Months with a break of 1 Month if found suitable by the competent authority. </p>
              <p> <span class="step_no">3</span>Junior Consultants shall be engaged on a full-time basis and would not be permitted to take up any other assignment during the period of their engagement. </p>
              <p> <span class="step_no">4</span>The engagement is purely on temporary basis and the appointment can be cancelled at any time without assigning any reason. National Skill Training Institute (NSTI), National Instructional Media Institute (NIMI) and Directorate General of Training (DGT) shall not be held responsible, legally for such decisions. </p>
              <p> <span class="step_no">5</span>The reservation policy and age relaxation as applicable for Central Government services will be followed in the selection process.</p>
              <p> <span class="step_no">6</span>A waitlist of qualified candidates (2 times the no. of vacancies) may be prepared and kept with the panel for three years. These waitlisted candidates may be considered against non-acceptance/on resignation of the JCs. </p>
              <p> <span class="step_no">7</span>At the time of joining of the Junior Consultant at the respective NSTI/CSTARI, an agreement on stamp paper of Rs.100 /- duly notarized, must be signed between the Director/Principal of the Institute and candidate (Junior Consultant). </p>
              <p> <span class="step_no">8</span>The DGT reserves the right to increase/decrease the number of post at the time of selection depending upon requirement or cancel this process of engagement at any stage without assigning any reason. </p>
              <p> <span class="step_no">9</span>Mere submission of application, appearing in exam or selection shall not entitle the candidate for any job claim in future.</p>        </div>
          </div>
        </div>
        <!-- feature box close -->




  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-list-alt"></i>
      <div class="text para_cls">
        <h3>Selection Process</h3>
        <p><span class="step_no">1</span>Submission of online application by candidates</p>
        <p><span class="step_no">2</span>Scrutinizing of Applications received and Issue of Admit Card </p>
        <p><span class="step_no">3</span>Conduct of All India CBT Exam for selection of pool of candidates Online </p>
        <p><span class="step_no">4</span>Calling the CBT qualified candidates Regional wise for Practical Exams in order of Merit (based on CBT marks) in 1:6 ratios digitally </p>
        <p><span class="step_no">5</span>Conduction of Practical Exams, Region wise for selected candidates </p>
        <p><span class="step_no">6</span>Calculation of Score Card and Result of the Candidates (3 Times the number of JCs) in order of merit as per the Score card.</p>
        <p><span class="step_no">7</span>Selected candidates Panel list (3 Times the number of JCs) published by DGT  </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-book"></i>
      <div class="text para_cls">
        <h3>Application Fees</h3>
        <table>
            <thead>
                <th style="width: 15%; text-align: center;">Category</th>
                <th style="width: 15%; text-align: center;">Fees</th>
            </thead>
            <tr>
                <td>General, OBC, EWS </td>
                <td>INR 500 (Five Hundred Rupees only) to be
                    paid
                    online during the application process
                    </td>
            </tr>
            <tr>
                <td>SC/ST/PwD/Women</td>
                <td>Exempted</td>
            </tr>
        </table>
        
        <!-- <p><span class="step_no">1</span>Rs. 500 to be paid online during the application process.</p> -->

      </div>
    </div>
  </div>
  <!-- feature box close -->


    <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
      <div class="feature-box style-2 left">
        <i class="fa fa-calculator"></i>
        <div class="text">
          <h3>Score Card Calculation Matrix</h3>

          <div class="container">
            <div class="row">

              <div class="col-md-12">
                <table>
                  <thead>
                      <th>S.No</th>
                      <th>Criteria</th>
                      <th style="width: 15%; text-align: center;">Maximum Marks</th>
                      <!-- <th style="text-align: center;">Split up</th> -->
                  </thead>

                  <tr>
                    <td>1</td>
                    <td>CBT Examination (150 Marks) </td>
                    <td class="num_marks">40 % of CBT Marks</td>
                    <!-- <td>Total CBT Marks obtained out of 100 Marks  </td> -->
                  </tr>

                  <tr>
                    <td>2</td>
                    <td>Skill Test (100 Marks)  </td>
                      <td class="num_marks">20% of Skill Test Marks </td>
                    <!-- <td> Total Practical Marks obtained out of 100 Marks -->
          <!-- 2 Marks per year of Experience after acquiring minimum qualification & experience as prescribed in Para C above.  -->
                       <!-- </td> -->
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Experience
                        (Weightage of experience will be given over and above the minimum experience required for the post e.g. If a B.Tech candidate possesses 5 years experience after acquiring B.Tech, he/she will be given weightage of 3 years. Points for experience per year would be 40)
                          </td>
                    <td class="num_marks">5% of Points gained through
                        Experience
                         </td>
                    <!-- <td>	<p>2 Marks per year of Experience after acquiring minimum qualification & experience as prescribed in Para C above</p>
                      <p> (Maximum limit is 10 Marks for 5 years of experience after acquiring minimum qualification & experience as prescribed in Para C above.)  </p>
                    </td> -->

                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Qualification Points *  
                        <tr>
                            <td>NTC/NAC</td>
                            <td>100Points</td>
                        </tr>
                        <tr>
                            <td>Diploma</td>
                            <td>40 points</td>
                        </tr>
                        <tr>
                            <td>Degree</td>
                            <td>30 Points</td>
                        </tr>
                    </td>
                    <td class="num_marks"> 35% of Points gained through Qualification </td>
                    <!-- <td>	<p> For CITS with Degree or higher 	50 Marks  </p>
                      <p> For CITS with Diploma 	40 Marks </p>
                    <p>		For CITS 	30 Marks </p>
                    </td> -->

                  </tr>
                  <!-- <tr class="last_tr">
                    <td></td>
                    <td>Total Marks </td>
                    <td class="num_marks">  260 </td>
                    <td></td>
                  </tr> -->

                </table>

                <p>The candidate will be given the benefit of all the qualification possessed by him/her i.e. if a candidate possesses CITS +Diploma +Degree, he/she will get benefit of all qualification and weightage (35%) will be given accordingly.</p>
              </div>
            </div>
          </div>


        </div>
      </div>


      <!--Content Start-->


      <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-book"></i>
          <div class="text para_cls">
            <h3>Sequence of Events</h3>
            <table>
                <thead>
                    <th>Sl. No</th>
                    <th>Activity</th>
                </thead>
                <tr>
                    <td>1</td>
                    <td>Issue of Admit Cards to the Candidates</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>Conduct of Computer Based Test (CBT) in respective NSTIs</td>
                </tr>
                <tr>
                    <td>3</td>
                        <td>Mapping of candidates on basis of trade available at the nearest NSTI for
                        conducting practical examination for the CBT qualified candidates in order of merit & communicating to the short-listed candidates (1:6 ratio)
                    </td>
                    </tr>
                <tr>
                    <td>4</td>
                        <td>Document Verification and Practical Examination</td>
                </tr>
                <tr>
                    <td>5</td>
                        <td>Result Declaration</td>
                </tr>
                <tr>
                    <td>6</td>
                        <td>Submission of panel list for selected candidates 
                        (2 times the number of JCs) and score card
                    </td>
                    </tr>
            </table>
          </div>
        </div>
      </div>


      <!--Content End-->

        <!--Content Start-->






      <!--Content End-->



    </div>
    <!-- feature box close -->


     <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-gavel"></i>
      <div class="text para_cls">
        <h3>Tie Breaker Rules</h3>


        <div class="container">
          <div class="row">

            <div class="col-md-12">
                If two candidates secure the same score, the following tie breaking rules will be applicable.
            </div>
            <div class="col-md-12">
              <table>
                <thead>
                    <th>Sl.No</th>
                    <th style="width: 50%; text-align: center;"> Preference</th>
                    <th> Rule</th>
                </thead>

                <tr>
                  <td>1</td>
                  <td> First  </td>
                  <td> NTC/NAC </td>
                </tr>

                <tr>
                  <td>2</td>
                  <td>Second </td>
                    <td>Ex-Servicemen  </td>

                </tr>

                <tr>
                  <td>3</td>
                  <td>Third </td>
                  <td>Skill Test Marks</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Fourth</td>
                  <td>CBT Marks </td>
                </tr>

                <!-- <tr>
                  <td>5</td>
                  <td>Fifth Preference   </td>
                  <td> CBT Marks   </td>
                </tr> -->
                <!-- <tr style="border-bottom: 1px solid #999;">
                  <td>6</td>
                  <td>Sixth Preference    </td>
                  <td> Retired Govt. Employee with experience in the relevant field    </td>
                </tr> -->
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- feature box close -->

  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-gavel"></i>
      <div class="text para_cls">
        <h3>Sequence of Events</h3>


        <div class="container">
          <div class="row">

            <!-- <div class="col-md-12">
                If two candidates secure the same score, the following tie breaking rules will be applicable.
            </div> -->
            <div class="col-md-12">
              <table>
                <thead>
                    <th>Sl.No</th>
                    <th style="width: 50%; text-align: center;"> Activity</th>
                    <th> Timeline</th>
                </thead>

                <tr>
                  <td>1</td>
                  <td> Closing date of application portal   </td>
                  <td> 29.12.2024 </td>
                </tr>

                <tr>
                  <td>2</td>
                  <td>Conduct of Computer Based Test (CBT) in respective NSTIs </td>
                    <td>12.01.2025  </td>

                </tr>

                <tr>
                  <td>3</td>
                  <td>Mapping of candidates on basis of trade available at the nearest NSTI for conducting practical examination for the CBT qualified candidates in order of merit & communicating to the short-listed candidates (1:6 ratio) </td>
                  <td>14.01.2025
                    to
                    17.01.2025
                    </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Documents verification and Conduct of Practical Examination</td>
                  <td>23.01.2025
                    to 
                    24.01.2025
                     </td>
                </tr>

                <!-- <tr>
                  <td>5</td>
                  <td>Fifth Preference   </td>
                  <td> CBT Marks   </td>
                </tr> -->
                <!-- <tr style="border-bottom: 1px solid #999;">
                  <td>6</td>
                  <td>Sixth Preference    </td>
                  <td> Retired Govt. Employee with experience in the relevant field    </td>
                </tr> -->
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

       <!-- feature box begin -->
       <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-clock-o"></i>
          <div class="text para_cls">
            <h3>Recruitment Process and Time Schedule </h3>


            <div class="container">
              <div class="row">


                <div class="col-md-12">
                  <table>
                    <thead>
                      <td>Sl.no</td>
                      <td style="width: 50%;">Activity/Process</td>
                      <td>Timelines</td>
                      <td>To be done by</td>
                    </thead>
                    <tr>
                      <td>1</td>
                      <td> Publishing of the Applications Centrally Online for engaging Junior Consultants  </td>
                      <td> 09-04-2021  </td>
                      <td> by NIMI  </td>
                    </tr>

                    <tr>
                      <td>2</td>
                      <td>Scrutinizing of Applications received, Issue of Admit Card   </td>
                        <td>13-05-21 to 15-05-21  </td>
                        <td> by NIMI  </td>
                    </tr>

                    <tr>
                      <td>3</td>
                      <td>Informing the CBT qualified candidates Regional wise for Practical Exams in order of Merit (based on CBT marks) in 1:6 ratio digitally   </td>
                      <td>22-05-2021    </td>
                      <td> by NIMI  </td>

                    </tr>
                    <tr>
                      <td>4</td>
                      <td> Conduct of All India CBT Exam for selection of pool of candidates Online </td>
                      <td> 29-05-21 to 31-05-21  </td>
                      <td> by NIMI  </td>
                    </tr>

                    <tr>
                      <td>5</td>
                      <td>Practical Exams to be conducted Region wise for above sorted candidates Issue of call letters to meritorious candidates   </td>
                      <td> 14-06-21 to 16-06-21   </td>
                      <td> by NSTIs  </td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td> Issue of call letters to meritorious candidates   </td>
                      <td>    </td>
                      <td> by NSTIs  </td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Calculation of Score Card/Result of the Candidates (3 Times the number of JCs) in order of merit as per the Score card rule mentioned in JC guidelines    </td>
                      <td>  25-06-2021    </td>
                      <td> by NIMI  </td>
                    </tr>
                    <tr style="border-bottom: 1px solid #999;">
                      <td>8</td>
                      <td>Selected candidates Panel list (3 Times the number of JCs) with scorecard to be sent from NIMI to DGT HQRS for approval   </td>
                      <td>  30-06-2021    </td>
                      <td> by NIMI  </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div> -->
      <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>The Entitlements </h3>

        <p><span class="step_no">1</span>The full-time candidates will be paid a monthly consolidated remuneration of Rs. 55,000/- </p>
        <p><span class="step_no">2</span>The JCs will not be eligible for Government Accommodation or House Rent Allowance, CGHS facility, Official email i.d., Government identification card, internet connection, telephone, etc.  </p>
        <p><span class="step_no">3</span>If the tour program of JC is in public interest, he/she will be entitled for TA/DA as applicable to an official in the Level-6 of Pay Matrix. In case of retired govt. employees, orders of Dept of Expenditure will be applicable.  </p>
        <p><span class="step_no">4</span>The JCs shall be entitled to avail leave of 8 days in a year on prorata basis</p>
        <p><span class="step_no">5</span> The JCs will be expected to discharge their duties with utmost honesty and sincerity and keep secrecy of office. In case, the services of the JCs are not found satisfactory or found in conflict with the interests of the Government, their services	will be liable for termination without any notice and assigning any reasons. However, in the normal case, one month’s notice will be provided by either side. </p>
        <!-- <p> <span class="step_no">6</span> <b> Conflict of interest:  </b> He/she will be expected to display utmost honesty, secrecy of office and sincerely while discharging his/her duties. In case, the services of the Consultant are not found satisfactory or found in conflict with the interests of the Government, his/her services will be liable for discontinuation without assigning any reason.
          </p>
          <p> <span class="step_no">7</span> <b> Termination Notice:  </b> The Competent Authority can cancel the appointment at any time without providing any reason for it. However, in the normal course it will provide one month’s notice to the Consultant.
          </p> -->
      </div>
    </div>
  </div>
  <!-- feature box close -->

      </div>
    </div>

    <!-- <div class="col-md-4">
      <figure class="picframe invert transparent hover-shadow rounded">
                            <span class="overlay-v">
            <span class="v-center">
              <span>
                <a id="play-video" class="video-play-button popup-youtube" href="https://www.youtube.com/watch?v=CmCIZ_aUAeQ">
                  <span></span>
                </a>
              </span>
            </span>
          </span>
                        <img src="assets/images/misc/2.jpg" class="img-fullwidth" alt="">
                    </figure>
    </div> -->
  </div>

        </div>
    </section>
    <!-- section close -->

<!-- section begin -->
    <section class="bg-color text-light pt60 pb60">
        <div class="container">

            <div class="row">
                <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
                    <div class="de_count">
                        <h3 class="timer" data-to="29" data-speed="2500">29</h3>
                        <span>Institutes </span>
                    </div>
                </div>

                <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
                    <div class="de_count">
                        <h3 class="timer" data-to="80">80</h3>
                        <span>VACANCIES</span>
                    </div>
                </div>



                <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
                    <div class="de_count">
                        <h3 class="timer" data-to="50" data-speed="2500">50</h3>
                        <span>NSTI-G</span>
                    </div>
                </div>

                <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
                  <div class="de_count">
                      <h3 class="timer" data-to="26" data-speed="2500">26</h3>
                      <span>NSTI-W</span>
                  </div>
              </div>
              <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
                <div class="de_count">
                    <h3 class="timer" data-to="4" data-speed="2500">4</h3>
                    <span>CSTARI</span>
                </div>
            </div>
            <div class="col-md-2 col-sm-6 col-xs-6 mb-sm-30">
              <div class="de_count">
                  <h3 class="timer" data-to="55000">55000</h3>
                  <span>remuneration</span>
              </div>
          </div>
            </div>
        </div>
    </section>
    <!-- section close -->


    <div class="row notifi_main_table ">
      <div class="col-md-12">
    <h2>
        Vacancy Details
    </h2>
    <p style="text-align: center;"><strong>(a) Trade-Wise Vacancy</strong></p>

          <!--Content Start-->




          <div class="container">
            <div class="row">

              <div class="col-md-12">
                <table>
                  <thead>
                      <th>S.No</th>
                      <th>Trade Name  </th>
                      <th style="text-align: center;">NSTI-G </th>
                      <th style="text-align: center;">NSTI-W </th>                      
                  </thead>
                  <tr><td>1</td><td>Computer Aided Embroidery & Designing</td><td>0</td><td>1</td></tr>
                  <tr><td>2</td><td>Computer Software Application </td><td>8</td><td>3</td></tr>
                  <tr><td>3</td><td>Computer Hardware and Networking Maintenance </td><td>4</td><td>0</td></tr>
                  <tr><td>4</td><td>Cosmetology</td><td>0</td><td>6</td></tr>
                  <tr><td>5</td><td>Draughtsman Civil </td><td>2</td><td>1</td></tr>
                  <tr><td>6</td><td>Draughtsman Mechanical </td><td>1</td><td>0</td></tr>
                  <tr><td>7</td><td>Dress Making </td><td>1</td><td>2</td></tr>
                  <tr><td>8</td><td>Electrician </td><td>8</td><td>2</td></tr>
                  <tr><td>9</td><td>Electronics Mechanic </td><td>3</td><td>1</td></tr>
                  <tr><td>10</td><td>Fashion Design & Technology </td><td>0</td><td>3</td></tr>
                  <tr><td>11</td><td>Fitter </td><td>8</td><td>0</td></tr>
                  <tr><td>12</td><td>Information Technology </td><td>1</td><td>0</td></tr>
                  <tr><td>13</td><td>Machinist and Operator Advanced Machine
                    Tools
                     </td><td>1</td><td>0</td></tr>
                  <tr><td>14</td><td>Mechanic Diesel </td><td>1</td><td>0</td></tr>
                  <tr><td>15</td><td>Mechanic Motor Vehicle </td><td>1</td><td>0</td></tr>
                  <tr><td>16</td><td>Mechanic Refrigeration and Air-Conditioning </td><td>1</td><td>0</td></tr>
                  <tr><td>17</td><td>Office Management </td><td>1</td><td>2</td></tr>
                  <tr><td>18</td><td>Plumber </td><td>1</td><td>0</td></tr>
                  <tr><td>19</td><td>Sewing Technology </td><td>2</td><td>1</td></tr>
                  <tr><td>20</td><td>Surface Ornamentation Technique </td><td>0</td><td>1</td></tr>
                  <tr><td>21</td><td>Welder </td><td>4</td><td>0</td></tr>
                  <tr><td>22</td><td>Training Methodology (POT) </td><td>6</td><td>3</td></tr>
                  <!-- <tr><td>21</td><td>Mechanic Refrigeration and Air-conditioning </td><td>1</td><td>0</td></tr>
                  <tr><td>22</td><td>Mechanic Motor Vehicle </td><td>1</td><td>0</td></tr>
                  <tr><td>23</td><td>Office Management </td><td>0</td><td>0</td></tr>
                  <tr><td>24</td><td>Plumber </td><td>1</td><td>0</td></tr>
                  <tr><td>25</td><td>Secretarial Practice (Hindi) </td><td>0</td><td>0</td></tr>
                  <tr><td>26</td><td>Sewing Technology </td><td>2</td><td>0</td></tr>
                  <tr><td>27</td><td>Sheet Metal Worker </td><td>0</td><td>0</td></tr>
                  <tr><td>28</td><td>Tool and Die Maker </td><td>0</td><td>0</td></tr>
                  <tr><td>29</td><td>Surface Ornamentation Technique </td><td>0</td><td>0</td></tr>
                  <tr><td>30</td><td>Mechanic Tractor </td><td>0</td><td>0</td></tr>
                  <tr><td>31</td><td>Turner </td><td>0</td><td>0</td></tr>
                  <tr><td>32</td><td>Welder </td><td>5</td><td>0</td></tr>
                  <tr><td>33</td><td>Draughtsman Mechanical /RODA/ED </td><td>1</td><td>0</td></tr>
                  <tr><td>34</td><td>Workshop Calculation & Science </td><td>3</td><td>8</td></tr>
                  <tr><td>35</td><td>POT </td><td>13</td><td>1</td></tr>
                  <tr><td>36</td><td>Soft Skilll</td><td>0</td><td>9</td></tr> -->
                  <tr class="last_tr"><td> </td><td>Total</td><td>54</td><td>26</td></tr>





                </table>
              </div>
            </div>
          </div>

        <!--Content End-->

        <h2>
       (b) Institute-wise Vacancy 
        </h2>
        <p style="text-align: center;"><strong>For NSTI (General) </strong></p>
        <div class="container">
          <div class="row">

            <div class="col-md-12">
              <table>
                <thead>
                    <th>S.No</th>
                    <th>Name of the Institutes  </th>
                    <th>Total Vacancies </th>

                </thead>

                <tr><td>1</td><td>NSTI (V) Hyderabad</td><td>2</td></tr>
        <tr><td>2</td><td>NSTI Bengaluru</td><td>1</td></tr>
<tr><td>3</td><td>NSTI Bhubaneshwar</td><td>1</td></tr>
<tr><td>4</td><td>NSTI Chennai</td><td>4</td></tr>
<tr><td>5</td><td>NSTI Dehradun</td><td>5</td></tr>
<tr><td>6</td><td>NSTI Extension Center Andhra Pradesh (Vizag)</td><td>1</td></tr>
<tr><td>7</td><td>NSTI Extension Center Srinagar</td><td>2</td></tr>
<tr><td>8</td><td>NSTI Haldwani</td><td>2</td></tr>
<tr><td>9</td><td>NSTI Howrah</td><td>6</td></tr>
<tr><td>10</td><td>NSTI Jamshedpur</td><td>1</td></tr>
<tr><td>11</td><td>NSTI Jodhpur</td><td>2</td></tr>
<tr><td>12</td><td>NSTI Kanpur</td><td>11</td></tr>
<tr><td>13</td><td>NSTI Ludhiana</td><td>6</td></tr>
<tr><td>14</td><td>NSTI Mumbai</td><td>4</td></tr>
<tr><td>15</td><td>NSTI-R Hyderabad</td><td>2</td></tr>
<tr><td>16</td><td>CSTARI</td><td>4</td></tr>
<tr class="last_tr"><td> </td><td>TOTAL </td><td>54</td></tr>
</table>


</div>
</div>
        </div>
        <p style="text-align: center;"><strong>For NSTI (Women) </strong></p>
<div class="container">
    <div class="row">
        <div class="col-md-12">
            <table>
                <thead>
                    <th>Sl.no</th>
                    <th>Name of the NSTI</th>
                    <th>Total Vacancies</th>
                </thead>
                
                    <tr><td>1</td><td>NSTI (W) Tura</td><td>1</td></tr>
        <tr><td>2</td><td>NSTI (W) Allahabad</td><td>2</td></tr>
        <tr><td>3</td><td>NSTI (W) Vadodara</td><td>3</td></tr>
        <tr><td>4</td><td>NSTI (W) Goa</td><td>1</td></tr>
        <tr><td>5</td><td>NSTI (W) Hyderabad</td><td>2</td></tr>
        <tr><td>6</td><td>NSTI (W) Indore</td><td>2</td></tr>
        <tr><td>7</td><td>NSTI (W) Jaipur</td><td>1</td></tr>
        <tr><td>8</td><td>NSTI (W) Jammu</td><td>2</td></tr>
        <tr><td>9</td><td>NSTI (W) Noida</td><td>2</td></tr>
        <tr><td>10</td><td>NSTI (W) Mohali</td><td>1</td></tr>
        <tr><td>11</td><td>NSTI (W) Panipat</td><td>5</td></tr>
        <tr><td>12</td><td>NSTI (W) Patna</td><td>2</td></tr>
        <tr><td>13</td><td>NSTI (W) Shimla</td><td>2</td></tr>
        
        <tr class="last_tr"><td> </td><td>TOTAL </td><td>26</td></tr>
                
            </table>
        </div>
    </div>
</div>
        
        
        
        <!-- general terms & conditions -->

        <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
            <div class="feature-box style-2 left">
               <i class="fa fa-globe"></i> 
              <div class="text para_cls">
                                 
                
                <div class="col-md-12 feature-box mb40 sq-item wow">
                    <div class="feature-box style-2 left">
                      <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                      <div class="text para_cls">               
                        <h3>General Terms & Conditions </h3>
                <p><span class="step-no">1</span>Junior Consultants (JCs) will be engaged for a period of eleven months from the date of Engagement.</p>
                <p><span class="step-no">2</span>The services of JCs may be extended for a period of another 11 Months with a break of 1 Month if found suitable by the competent authority.</p>
                <p><span class="step-no">3</span>Junior Consultants shall be engaged on a full-time basis and would not be permitted to take up any other assignment during the period of their engagement.</p>
                <p><span class="step-no">4</span>The engagement is purely on temporary basis and the appointment can be cancelled at any time without assigning any reason. National Skill Training Institute (NSTI), National Instructional Media Institute (NIMI) and Directorate General of Training (DGT) shall not be held responsible, legally for such decisions.</p>
                <p><span class="step-no">5</span>The reservation policy and age relaxation as applicable for Central Government services will be followed in the selection process.</p>
                <p><span class="step-no">6</span>A waitlist of qualified candidates (2 times the no. of vacancies) may be prepared and kept with the panel for three years. These waitlisted candidates may be considered against non-acceptance/on resignation of the JCs.</p>
                <p><span class="step-no">7</span>At the time of joining of the Junior Consultant at the respective NSTI/CSTARI, an agreement on stamp paper of Rs.100 /- duly notarized, must be signed between the Director/Principal of the Institute and candidate (Junior Consultant).</p>
                <p><span class="step-no">8</span>The DGT reserves the right to increase/decrease the number of post at the time of selection depending upon requirement or cancel this process of engagement at any stage without assigning any reason.</p>
                <p><span class="step-no">9</span>Mere submission of application, appearing in exam or selection shall not entitle the candidate for any job claim in future.</p>

              </div>
            </div>
        </div>

        
         <h2>
          JC Training vacancies Trade wise Institutes wise
        </h2>

        <div class="container">
          <div class="row">

            <div class="col-md-12">
              <table style="display: block; overflow: scroll; height: 500px;">
                <thead>
                <th>Sl. no.</th><th>CITS Trades / NSTI(G)</th><th>NSTI W Noida</th><th>NSTI W Mumbai</th><th>NSTI W Bangalore</th><th>NSTI W Kolkata</th><th>NSTI W Tura</th><th>NSTI W Indore</th><th>NSTI W Vadodara</th><th>NSTI W Allahabad</th><th>NSTI W Jaipur</th><th>NSTI W Shimla</th><th>NSTI W Jammu</th><th>NSTI Chennai</th><th>NSTI Calicut</th><th>NSTI Hyderabad (V)</th><th>NSTI Jodhpur</th><th>NSTI Ludhiana</th><th>NSTI Haldwani</th><th>NSTI Mumbai</th><th>NSTI Dehradun</th><th>NSTI Hyderabad R</th><th>NSTI Kolkata, Howrah</th><th>NSTI Kanpur</th><th>NSTI Jamshedpur</th><th>NSTI Bengaluru</th><th>Vacancies in CSTARI</th><th>Vacancies in NSTI(G)</th><th>Vacancies in NSTI(W)</th><th>Trade Vacancies</th>
                </thead>
                <tr><td>1</td><td>Carpenter</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>1</td></tr>
                <tr><td>2</td><td>Computer Hardware & Maintenance</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>2</td><td>0</td><td>3</td></tr>
                <tr><td>3</td><td>Computer Software Application</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>1</td><td>0</td><td>1</td><td>0</td><td>1</td><td>1</td><td>6</td><td>1</td><td>8</td></tr>
                <tr><td>4</td><td>Draughtsman Civil</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>1</td><td>3</td></tr>
                <tr><td>5</td><td>Dress making</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td></tr>
                <tr><td>6</td><td>Electrician/wireman</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>2</td><td>0</td><td>2</td></tr>
                <tr><td>7</td><td>Electronics Mechanic</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td><td>0</td><td>1</td><td>0</td><td>3</td><td>0</td><td>3</td></tr>
                <tr><td>8</td><td>Fitter</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td><td>0</td><td>1</td><td>4</td><td>0</td><td>5</td></tr>
                <tr><td>9</td><td>Foundryman</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td></tr>
                <tr><td>10</td><td>Machinist & Operator Advance Machine Tool</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>2</td></tr>
                <tr><td>11</td><td>Mechanic Diesel</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>2</td></tr>
                <tr><td>12</td><td>Mechanic Refrigeration and Air-conditioning</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>2</td></tr>
                <tr><td>13</td><td>Mechanic Motor Vehicle</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>2</td></tr>
                <tr><td>14</td><td>Plumber</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td></tr>
                <tr><td>15</td><td>Sewing Technology</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>2</td><td>0</td><td>0</td><td>1</td><td>2</td><td>0</td><td>3</td></tr>
                <tr><td>16</td><td>Welder</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>1</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td><td>1</td><td>5</td><td>0</td><td>6</td></tr>
                <tr><td>17</td><td>Draughtsman Mechanical /RODA/ED</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>1</td></tr>
                <tr><td>18</td><td>Workshop Calculation & Science</td><td>1</td><td>1</td><td>1</td><td>1</td><td>0</td><td>0</td><td>1</td><td>1</td><td>1</td><td>1</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>3</td><td>8</td><td>11</td></tr>
                <tr><td>19</td><td>POT/Technical Officer</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>1</td><td>2</td><td>2</td><td>0</td><td>1</td><td>0</td><td>2</td><td>2</td><td>0</td><td>3</td><td>0</td><td>0</td><td>0</td><td>0</td><td>13</td><td>1</td><td>14</td></tr>
                <tr><td>20</td><td>Soft Skills</td><td>1</td><td>1</td><td>1</td><td>1</td><td>1</td><td>1</td><td>0</td><td>1</td><td>1</td><td>0</td><td>1</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>0</td><td>9</td><td>9</td></tr>
                <tr class="last_tr"><td></td><td>Total</td><td>2</td><td>2</td><td>2</td><td>2</td><td>1</td><td>1</td><td>1</td><td>3</td><td>2</td><td>2</td><td>2</td><td>7</td><td>3</td><td>2</td><td>2</td><td>2</td><td>2</td><td>7</td><td>4</td><td>3</td><td>6</td><td>6</td><td>2</td><td>3</td><td>11</td><td>49</td><td>20</td><td>80</td></tr>
                </table>
</div>
</div>
        </div>

      </div>
    </div> -->

    <section id="section-services">
        <div class="col-md-12 feature-box mb40 sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-globe"></i>
              <div class="text para_cls">         
            <h3>CBT Exam Pattern</h3>
            
            <p>Total Marks = 150</p>
            <p>Total Number of Questions = 50 </p>
            <p>Marks per question = 3 </p>
            <p>Break Up of Questions
                o Training Methodology (TM) and Employability Skills (ES) (TM: ES = 30:20)
                </p>     
                      
          </div>
        </div>
      </div>
</section>
</div>
</div>
    <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center; padding: 30px 0px;">
      <a href="http://nimiprojects.in/recruitment/register_jc.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
  </div>

  <div class="container big_padd">








      </div>



    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
